import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { Fragment } from "react";

const EfileStatusListBox = ({
  efileStatuses,
  selectedEfileStatus,
  onChange,
  placeholder = "Not Assigned",
  className = "mt-5 sm:mt-6",
}) => {

  return (
    <div className={className}>
      <Listbox
        as="div"
        className="relative inline-block w-full text-left"
        value={selectedEfileStatus}
        onChange={onChange}
      >
        <Listbox.Label
          className="block text-left text-sm font-medium text-gray-700"
        >
          E-file Status
        </Listbox.Label>
        <div>
          <Listbox.Button className="mt-1 inline-flex min-h-[42px] w-full touch-manipulation items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-normal text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-1">
            <span className="truncate">
              {selectedEfileStatus !== null
                ? selectedEfileStatus
                : placeholder}
            </span>
            <ChevronUpDownIcon className="ml-2 h-5 w-5 shrink-0" aria-hidden="true" />
          </Listbox.Button>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Listbox.Options className="absolute inset-x-0 z-[240] mt-2 max-h-60 w-full origin-top overflow-auto overscroll-contain rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              {efileStatuses.map((efileStatus) => (
                <Listbox.Option
                  name="efileStatus"
                  key={efileStatus}
                  value={efileStatus}
                  className={({ active }) =>
                    `${active ? "bg-teal-600 text-white" : "text-gray-900"} relative cursor-pointer select-none px-4 py-3 pl-10 text-sm`
                  }
                >
                  {({ active, selected }) => (
                    <>
                      {selected && (
                        <span
                          className={`${
                            active ? "text-white" : "text-teal-600"
                          } absolute inset-y-0 left-0 flex items-center pl-3`}
                        >
                          <CheckIcon className="h-5 w-5" />
                        </span>
                      )}
                      <span
                        className={`${
                          selected ? "font-semibold" : "font-normal"
                        } block truncate`}
                      >
                        {efileStatus}
                      </span>
                    </>
                  )}
                </Listbox.Option>
              ))}
          </Listbox.Options>
        </Transition>
      </Listbox>
    </div>
  );
};

export default EfileStatusListBox;
